export const GET_COMMENTS = 'GET_COMMENTS';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const EDIT_COMMENT = 'EDIT_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const GET_MENTION_STAFF = 'GET_MENTION_STAFF';
export const GET_MENTION_STAFF_SUCCESS = 'GET_MENTION_STAFF_SUCCESS';
